import React from "react";
import Link from "next/link";
import { Grid } from "@mui/material";
import { getAssets } from "@unisearch/helpers";
import styles from "./get_result.module.scss";

export const UniPageAnalyticsGetResult = () => {
  return (
    <section className={styles.section_get_result}>
      <div className="container">
        <Grid container spacing={4} alignItems="center">
          <Grid item sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/unipage/uni_campus.png")}
                alt="Uni Campus"
              />
            </div>
          </Grid>

          <Grid item sm={12} md={6}>
            <h2 className={styles.title}>
              Our Institution partners get immediate results
            </h2>
            <p className={`${styles.sub_title} font-medium`}>
              {`“We only had about six Sri Lankan students when I started working with Adventus.io and we’ve got more than 10x than that right now.” `}
            </p>
            <p className={`${styles.sub_title} font-medium`}>
              {`– CALLUM SAWATZKY- INTERNATIONAL RECRUITMENT, HUMBER COLLEGE, CANADA`}
            </p>

            <Link legacyBehavior href="/university/booking">
              <a className={`${styles.link} btn btn-bg btn-secondary`}>
                Learn More
              </a>
            </Link>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default UniPageAnalyticsGetResult;
